/**
 * Copyright since 2007 PrestaShop SA and Contributors
 * PrestaShop is an International Registered Trademark & Property of PrestaShop SA
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.md.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to https://devdocs.prestashop.com/ for more information.
 *
 * @author    PrestaShop SA and Contributors <contact@prestashop.com>
 * @copyright Since 2007 PrestaShop SA and Contributors
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 */
/* eslint-disable */
import 'expose-loader?Tether!tether';
import 'bootstrap/dist/js/bootstrap.min';
import 'flexibility';
import 'bootstrap-touchspin';
import 'jquery-touchswipe';
import './selectors';

import './responsive';
import './checkout';
import './customer';
import './listing';
import './product';
import './cart';

import prestashop from 'prestashop';
import EventEmitter from 'events';
import DropDown from './components/drop-down';
import Form from './components/form';
import ProductMinitature from './components/product-miniature';
import ProductSelect from './components/product-select';
import TopMenu from './components/top-menu';

import './lib/bootstrap-filestyle.min';
import './lib/jquery.scrollbox.min';

import './components/block-cart';
import $ from 'jquery';
/* eslint-enable */

// "inherit" EventEmitter
// eslint-disable-next-line
for (const i in EventEmitter.prototype) {
  prestashop[i] = EventEmitter.prototype[i];
}

/* @@DS Silences chatter on console */
jQuery.migrateMute = true;

$(document).ready(() => {
  const dropDownEl = $('.js-dropdown');
  const form = new Form();
  const topMenuEl = $('.js-top-menu ul[data-depth="0"]');
  const dropDown = new DropDown(dropDownEl);
  const topMenu = new TopMenu(topMenuEl);
  const productMinitature = new ProductMinitature();
  const productSelect = new ProductSelect();
  dropDown.init();
  form.init();
  topMenu.init();
  productMinitature.init();
  productSelect.init();

  $('.carousel[data-touch="true"]').swipe({
    swipe(event, direction) {
      if (direction === 'left') {
        $(this).carousel('next');
      }
      if (direction === 'right') {
        $(this).carousel('prev');
      }
    },
    allowPageScroll: 'vertical',
  });

  $('#search_widget')
      .on('shown.bs.collapse', function () {
        $(this).find('input[type=text]').focus();
      })
      .mouseout(function(){
        $(this).collapse('hide');
      });

  $('ok-search-toggle').click(function(){
    debugger;
    // setFixedHeader();
  });
  // setFixedHeader();

  /*
    Featured product slider
   */
  var featuredsliderConfig = {
    speed: 500,            // Integer: Speed of the transition, in milliseconds
    timeout: 5000, //$('.homeslider-container').data('interval'), // Integer: Time between slide transitions, in milliseconds
    pager: true,
    nav: false,             // Boolean: Show navigation, true or false
    random: false,          // Boolean: Randomize the order of the slides, true or false
    pause: true, //$('.homeslider-container').data('pause'), // Boolean: Pause on hover, true or false
    maxwidth: "",           // Integer: Max-width of the slideshow, in pixels
    namespace: "featuredslider",   // String: Change the default namespace used
    before: function(){},   // Function: Before callback
    after: function(){}     // Function: After callback
  };

  const featuredSlides = $("#index .products.row");
  if (featuredSlides.length === 1) {
    // @todo Cleanup
    featuredSlides.responsiveSlides(featuredsliderConfig);
  }

  /*
    Show form field comments only when field has errors
   */
  const formFields = $('form#customer-form .form-group');
  if (formFields.length > 0) {
    formFields
        .each(function() {
          if ($(this).hasClass('has-error')) {
            $(this).find('span.form-control-comment').show();//css('display', 'initial');
          }
        });
  }

  /*
    Disappearing email subscription
   */
  $('#blockEmailSubscription_displayFooterBefore')
      .on('shown.bs.collapse', function () {
        const elm = $(this);
        elm
            .find('input[type=email]')
            .focus();
        elm
            // .mouseout(function() {
            //   elm.collapse('hide');
            // })
            .focusout(function() {
              elm.collapse('hide');
            });
      });

  /*
    Makes contentbox same height as the featuredproducts slider
   */
  $('.ok-home-text .ok-content').css(
      'height',
      $('.products.row.featuredslider .product-thumbnail').css('height')
  );

  /*
    Moves 'current' class to menu top level
   */
  $('#top-menu > li').each(function () {
    const el = $(this);
    if (el.hasClass('current')) {
      return;
    }
    if (el.find('li.current').length > 0) {
      el.addClass('current');
      return;
    }
  });

  /*
    Show ok-wholesale-button "popup"
   */
  const wholesaleBtn = $('.okcustom-wholesale-button');
  const wholesaleDlg = $('.okcustom-wholesale-dialog');
  wholesaleBtn.find('.ok-pop').click(function () {
    wholesaleBtn.hide();
    wholesaleDlg.fadeIn();
    setTimeout(function (){
      wholesaleDlg.hide();
      wholesaleBtn.show();
    }, 10000);
    return false;
  });
  wholesaleDlg.find('.okclose').click(function (){
    wholesaleDlg.hide();
    wholesaleBtn.show();
  })
  shooters();
});

prestashop.okcustom = {
  fixedHeader: true, // Could be based on prestashop.responsive.mobile
};

function setFixedHeader() {
  if (prestashop.okcustom.fixedHeader) {
    const okHeader = $('#ok-header').addClass('navbar-fixed-top');
    $('body')
        .css('padding-top', okHeader.height())
        .css('z-index', 2000);
  }
}

if (!prestashop.responsive.mobile && prestashop.okcustom.fixedHeader) {
  console.log('fix header');
  $(window).scroll(function () {
    const elmBody = $('body');
    if ($(document).scrollTop() > 50) {
      elmBody.addClass('ok-shrink');
      $('#ok-header').addClass('ok-shrink');
    } else {
      elmBody.removeClass('ok-shrink');
      $('#ok-header').removeClass('ok-shrink');
    }
    setFixedHeader();
  });
}

// @@todo Cleanup
function shooters() {
  var docWidth = document.documentElement.offsetWidth;
  // const elm = $('#ok-header .header-top .container');
  const elm = $('body'); //$('#ok-header .header-nav');
  const target = elm.get(0);//      document.getElementById('ok-header');
  console.log('shooters of '+elm);
  [].forEach.call(
      target.querySelectorAll('*'),
      function (el) {
        if (el.offsetWidth > docWidth) {
          console.log(el);
        }
      }
  );
}
